export default __webpack_public_path__ + "static/media/slider_img3.7800366c.png";